import Colors from 'constants/Colors';

export default {
  category: {
    fontWeight: 'bold',
    marginTop: 8,
  },
  fieldsGrid: {
    display: 'grid',
    gridTemplateColumns: '24% 24% 24% 24%',
    padding: '0px',
    margin: '0px',
    boxSizing: 'border-box',
    gap: 8,
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 48,
    paddingBottom: 48,
  },
  button: {
    width: '22%',
    backgroundColor: Colors.blueColor,
    color: Colors.white,
  },
};
